import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import timezone from 'dayjs/plugin/timezone'

export const getRegistrationDates = () => {
  const yearsSpan = 100
  const minAge = 18

  const days = []
  const months = []
  const years = []

  let startYear = 0
  import('dayjs').then(({ default: dayjs }) => {
    startYear = parseInt(
      dayjs(dayjs().subtract(yearsSpan, 'year')).format('YYYY')
    )

    for (let day = 1; day <= 31; day++) {
      days.push({ value: day, label: day })
    }

    // const momentLang = lang === 'no' ? 'nb' : lang
    // const enGbLang = ['en', 'gb', 'ca', 'nz', 'ie']
    // const language = enGbLang.includes(lang) ? 'en-gb' : momentLang
    // const locale = require(`dayjs/locale/${language}`)
    // dayjs.locale(locale)

    const monthsString = [
      'January',
      'February',
      'March',
      'April',
      'May',
      'June',
      'July',
      'August',
      'September',
      'October',
      'November',
      'December',
    ]

    for (const month in monthsString) {
      // Currently we arent using the actual strings
      months.push({ value: parseInt(month) + 1, label: parseInt(month) + 1 })
    }

    for (let year = 0; year < yearsSpan; year++) {
      const value = startYear + year

      if (value < dayjs().year() - minAge + 1) {
        years.push({ value, label: value })
      }
    }

    years.reverse()
  })

  return {
    days,
    months,
    years,
  }
}

export const getDoubleDigitNumber = (number) => {
  return parseInt(number) < 10 ? number.padStart(2, '0') : number
}

export const getDateStr = (data) => {
  const { year, month, day } = data
  if (!year || !month || !day) return ''

  return `${year}-${getDoubleDigitNumber(month)}-${getDoubleDigitNumber(day)}`
}

export const getFormattedDate = (date, format = 'DD.MM.YYYY HH:mm:ss') => {
  dayjs.extend(utc)
  dayjs.extend(timezone)

  return dayjs(date).utc('z').local().tz(dayjs.tz.guess()).format(format)
}

export const getMinutesOrHoursFromSeconds = (
  seconds,
  minutesLabel,
  hoursLabel
) => {
  const numberSeconds = parseInt(seconds)
  const isLessThanHour = numberSeconds < 3600

  if (isLessThanHour) {
    const valueInMinutes = Math.floor(numberSeconds / 60)
    const correctMinutesLabel = minutesLabel.replace('s', '')
    const isExactlyOneMinute = numberSeconds === 60

    return `${valueInMinutes} ${
      isExactlyOneMinute ? correctMinutesLabel : minutesLabel
    }`
  }

  const correctHoursLabel = hoursLabel.replace('s', '')
  const isExactlyOneHour = numberSeconds === 3600
  const valueInHours = Math.floor(numberSeconds / 3600)

  return `${valueInHours} ${isExactlyOneHour ? correctHoursLabel : hoursLabel}`
}

export const hoursToMinutes = (hours) => hours * 60
export const daysToHours = (days) => days * 24
